export const OPEN_PENDING_CALL = 'OPEN_PENDING_CALL'
export const CLOSE_PENDING_CALL = 'CLOSE_PENDING_CALL'
